import React, { useEffect, useRef } from 'react';
import CloseIcon from 'src/icons/close-icon';
import LargePlayButton from 'src/icons/large-play-button';

const VideoInfo = ({ title, isPlaying, children, onClose, playerRef }) => {
  const overlayRef = useRef();
  const timerRef = useRef();

  function leaveFn() {
    const videoTitle = document.getElementById('hideContainer');
    if(timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      videoTitle.style.opacity = '0%';
    }, 100);
  }

  function moveFn() {
    const videoTitle = document.getElementById('hideContainer');
    videoTitle.style.opacity = '100%';
    if(timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      videoTitle.style.opacity = '0%';
    }, 2500);
  }

  function keyUp(e) {
    if(e.code !== 'Space') return;
    moveFn();
  }

  useEffect(() => {
    if(!overlayRef.current) return;
    document.addEventListener('keyup', keyUp);
    const playBtn = document.getElementById('play-btn-container');
    if(!isPlaying){
      const videoTitle = document.getElementById('hideContainer');
      videoTitle.style.opacity = '100%'; 
      playBtn.style.opacity = '100%';
      if(timerRef.current) clearTimeout(timerRef.current);
      return () => { document.removeEventListener('keyup', keyUp); };
    }
    playBtn.style.opacity = '0%';
    const ele = overlayRef.current;
    ele.addEventListener('mousemove', moveFn);
    ele.addEventListener('mouseleave', leaveFn);
    return  () => {
      ele.removeEventListener('mousemove', moveFn);
      ele.removeEventListener('mouseleave', leaveFn);
      document.removeEventListener('keyup', keyUp);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPlaying]);

  const handlePlayClick = (e) => {
    e.preventDefault();
    const videoPlayer = playerRef?.current?.getInternalPlayer();
    if(!videoPlayer) return;
    if(isPlaying)videoPlayer.pause()
    else videoPlayer.play();
  }

  return (
    <div className='video-overlay' ref={overlayRef}>
      <div className='video-title-box' id='hideContainer'>
        <h1 className='video-title'>{title}</h1>
      <button className='close-btn' onClick={onClose}>
        <CloseIcon />
      </button>
      </div>
      <div className='play-btn-container' id='play-btn-container' onClick={handlePlayClick}>
        <LargePlayButton />
      </div>
      {children}
    </div>
  )
}

export default VideoInfo